/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseDirectory } from './BaseDirectory';
import { BaseFile } from './BaseFile';
const DirectoryWithChildrenParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'entries',
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['file', BaseFile],
            ['directory', DirectoryWithChildren],
        ]))),
    ],
]), BaseDirectory);
export class DirectoryWithChildren extends BaseDirectory {
    static decode(input) {
        return DirectoryWithChildrenParser.decode(input).map(res => new DirectoryWithChildren(res));
    }
    static unsafeDecode(input) {
        return DirectoryWithChildren.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DirectoryWithChildrenParser.encode(data);
    }
    static schema() {
        return DirectoryWithChildrenParser.schema();
    }
}
